export default __webpack_public_path__ + "static/media/ecosystem-marketplace-access.6071837d.png";